"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const smoothscroll_polyfill_1 = __importDefault(require("smoothscroll-polyfill"));
smoothscroll_polyfill_1.default.polyfill();
const polyfills = [];
exports.default = polyfills;
